import React from "react";

function DeletefileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <rect width="20" height="20" fill="#D5D5D5" rx="2"></rect>
      <path
        fill="#000"
        d="M6 14.667C6 15.4 6.6 16 7.333 16h5.334C13.4 16 14 15.4 14 14.667v-8H6v8zm8.667-10h-2.334L11.667 4H8.333l-.666.667H5.333V6h9.334V4.667z"
      ></path>
    </svg>
  );
}

export default DeletefileIcon;
